const TOGGLE_COLLAPSE = "TOGGLE_COLLAPSE";

export default { TOGGLE_COLLAPSE };
